"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validNumbersLetters = exports.validPrefix = exports.validTime = exports.validEmail = exports.greaterThan = exports.greaterThanOrEqual = exports.lessOrEqual = exports.validInteger = exports.noBlankValuesInArray = exports.noForbiddenValueInArray = exports.requiredArray = exports.validTwoDecimals = exports.validPercent = exports.validAmount = exports.validNumber = exports.validColor = exports.required = void 0;
const EMAIL_REGEXP = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+/i;
const TIME_REGEXP = /^(?:(?:([01]?\d|2[0-3]):)?([0-5]?\d):)?([0-5]?\d)$/;
const required = (value, code = 'required') => value || value === 0
    ? undefined
    : [
        {
            code,
        },
    ];
exports.required = required;
const validColor = (value) => /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i.test(value)
    ? undefined
    : [
        {
            code: 'color_code',
            value,
        },
    ];
exports.validColor = validColor;
const validNumber = (value) => /^([0-9])+\.?[0-9]*$/.test(value)
    ? undefined
    : [
        {
            code: 'invalid_number',
            value,
        },
    ];
exports.validNumber = validNumber;
const validAmount = (value) => /^([0-9])+\.?[0-9]{0,2}$/.test(value)
    ? undefined
    : [
        {
            code: 'invalid_amount',
            value,
        },
    ];
exports.validAmount = validAmount;
// eslint-disable-next-line no-restricted-globals
const validPercent = (value) => !isNaN(value) && value >= 0 && value <= 100
    ? undefined
    : [
        {
            code: 'invalid_percent',
            value,
        },
    ];
exports.validPercent = validPercent;
// eslint-disable-next-line no-restricted-globals
const validTwoDecimals = (value) => !isNaN(value) && /^\d+(\.\d{1,2})?$/.test(value)
    ? undefined
    : [
        {
            code: 'invalid_decimals',
            value,
        },
    ];
exports.validTwoDecimals = validTwoDecimals;
const requiredArray = (values) => Array.isArray(values) && values.length
    ? undefined
    : [
        {
            code: 'required_array',
        },
    ];
exports.requiredArray = requiredArray;
const noForbiddenValueInArray = (values, forbidden, code) => {
    const forbiddenIndex = values.indexOf(forbidden);
    if (forbiddenIndex >= 0) {
        return values.map((val, index) => index === forbiddenIndex
            ? [
                {
                    code,
                },
            ]
            : undefined);
    }
    return undefined;
};
exports.noForbiddenValueInArray = noForbiddenValueInArray;
const noBlankValuesInArray = (array = [], code = 'required') => array.map((val) => !val
    ? [
        {
            code,
        },
    ]
    : undefined);
exports.noBlankValuesInArray = noBlankValuesInArray;
const validInteger = (value, code = 'integer') => Number.isInteger(Number(value))
    ? undefined
    : [
        {
            code,
        },
    ];
exports.validInteger = validInteger;
const lessOrEqual = (value, max, code = 'less_than_or_equal') => value > max
    ? [
        {
            value: max,
            code,
        },
    ]
    : undefined;
exports.lessOrEqual = lessOrEqual;
const greaterThanOrEqual = (value, min, code = 'greater_than_or_equal') => value < min
    ? [
        {
            value: min,
            code,
        },
    ]
    : undefined;
exports.greaterThanOrEqual = greaterThanOrEqual;
const greaterThan = (value, min, code = 'greater_than') => value <= min
    ? [
        {
            value: min,
            code,
        },
    ]
    : undefined;
exports.greaterThan = greaterThan;
const validEmail = (value) => EMAIL_REGEXP.test(value)
    ? undefined
    : [
        {
            code: 'email',
        },
    ];
exports.validEmail = validEmail;
const validTime = (value) => TIME_REGEXP.test(value)
    ? undefined
    : [
        {
            code: 'time',
        },
    ];
exports.validTime = validTime;
const validPrefix = (value) => /^[A-Za-z0-9]{1,8}$/.test(value) ? undefined : [{ code: 'regex' }];
exports.validPrefix = validPrefix;
const validNumbersLetters = (value) => /^[A-Za-z0-9]+$/.test(value) ? undefined : [{ code: 'numbers_and_letters' }];
exports.validNumbersLetters = validNumbersLetters;
